import { inject, Injectable } from '@angular/core';
import { Select, Store } from '@ngxs/store';
import { Observable } from 'rxjs';
import { CloseDialog, OpenDialog } from './info.actions';
import { InfoState } from './info.state';
import { InfoDialogItem } from 'src/app/models/info-dialog';

@Injectable({
  providedIn: 'root'
})
export class InfoDialogFacade {
  private readonly store = inject(Store);

  @Select(InfoState.open) open$: Observable<boolean>;
  @Select(InfoState.title) title$: Observable<string>;
  @Select(InfoState.description) description$: Observable<string>;
  @Select(InfoState.content) content$: Observable<InfoDialogItem[]>;
  @Select(InfoState.showActions) showActions$: Observable<boolean>;

  openDialog(title: string, description: string, content?: InfoDialogItem[], showActions?: boolean) {
    this.store.dispatch(new OpenDialog(title, description, content, showActions));
  }

  closeDialog() {
    this.store.dispatch(new CloseDialog());
  }
}
